import { Box, IconButton, OutlinedInput, Typography } from '@mui/material'

import Icon from 'components/UI/Icon'

import { useCalculateExtraWorkers } from '../helpers'

const ExtraWorkersCounter = ({
  extraWorkers = 0,
  setExtraWorkers,
  setTotalPayment,
  selectedPlan,
  selectedModality,
  paymentModality,
  currentWorkers,
  currentSubscriptionType,
  currentPlanPayment,
  getProratedPaymentValue,
}) => {
  const disableDecreaseButton = extraWorkers < 1

  const { calculateSubscriptionFromInput } = useCalculateExtraWorkers(
    getProratedPaymentValue
  )

  const callback = (data) =>
    setTotalPayment(
      getProratedPaymentValue
        ? data?.additional_workers_info?.extra_workers_value
        : data?.subscription_value?.[paymentModality]?.total
    )

  const handleChange = (event) => {
    setExtraWorkers(Number(event.target.value))
    calculateSubscriptionFromInput(
      {
        values: event.target.value,
        newPlanId: selectedPlan?.id,
        subscriptionType: selectedModality,
        workersNumber: currentWorkers + Number(event.target.value),
        currentSubscriptionType,
        currentPlanPayment,
      },
      callback
    )
  }

  const handleIncrease = () => {
    const newValue = extraWorkers + 1
    handleChange({ target: { value: newValue } })
  }

  const handleDecrease = () => {
    const newValue = extraWorkers - 1
    handleChange({ target: { value: newValue } })
  }

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down(400)]: {
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: theme.spacing(2),
        },
      })}
    >
      <Typography variant="h5">Agregar personas</Typography>
      <Box
        sx={(theme) => ({
          width: '9rem',
          display: 'grid',
          alignItems: 'center',
          justifyItems: 'center',
          gridTemplateColumns: '1fr 4fr 1fr',
          columnGap: theme.spacing(1),
          marginTop: theme.spacing(1),
        })}
      >
        <IconButton
          aria-label="decrease"
          color="primary"
          onClick={handleDecrease}
          disabled={disableDecreaseButton}
          size="large"
        >
          <Icon name="minus" />
        </IconButton>
        <OutlinedInput
          name="workers_number"
          variant="number"
          value={extraWorkers || ''}
          onChange={handleChange}
          inputProps={{
            type: 'number',
          }}
          sx={{
            height: '2.25rem',
            '& .MuiOutlinedInput-input': {
              textAlign: 'center',
            },
          }}
        />
        <IconButton
          aria-label="increase"
          color="primary"
          onClick={handleIncrease}
          size="large"
        >
          <Icon name="plus" />
        </IconButton>
      </Box>
    </Box>
  )
}

export default ExtraWorkersCounter
